import { css } from '@emotion/react';

import { zIndex } from 'shared/config';
import { mediaquery } from 'shared/styles/styleFunctions';
import theme from 'shared/styles/themes';

export default css({
  height: '100%',
  backgroundColor: 'white',
  overflow: 'hidden',
  display: 'flex',
  '.str-chat__channel-list--open': {
    position: 'absolute',
    left: 0,
    right: 0,
    width: '100vw',
    zIndex: zIndex.zDrawer,
    [mediaquery.md]: {
      display: 'unset',
    },
  },
  '.str-chat': {
    height: '100%',
    '&__channel-search-input--icon': {
      width: 0, // to hide the icon since cannot override the display property from str-chat styles
      marginRight: '-1.25rem', //to counteract the padding from str-chat styles that take precedence
    },

    '&__send-to-channel-checkbox__container label': {
      marginBottom: 0,
    },
    '&__channel-header': {
      borderBottom: `1px solid ${theme.colors.NEUTRAL200}`,
      display: 'flex',
      alignItems: 'center',
    },
    '&__header-livestream-left--title': {
      margin: `${theme.space[4]} 0`,
    },
    '&__date-separator': {
      paddingLeft: '0px',
      paddingRight: '0px',
    },
    '&__channel': {
      width: '100%',
    },
    '&__channel-list': {
      '.str-chat__channel-list-messenger__main': {
        padding: '10px',
        height: 'calc(100% - 65px)',
      },
      '&:not(.str-chat__channel-list--open)': {
        display: 'none',
        [mediaquery.md]: {
          display: 'unset',
        },
      },

      minHeight: '80vh',

      [mediaquery.md]: {
        width: '300px',
      },
    },
    '&__channel-preview-messenger--unread, &__channel-preview-messenger--unread .str-chat__channel-preview-messenger--name':
      {
        fontWeight: 'bold',
      },
    '&-for-brands': {
      '.str-chat__message--received:not(.str-chat__message--me) .str-chat__avatar': {
        cursor: 'pointer',
      },
    },
    '.str-chat__reaction-list': {
      zIndex: zIndex.zBackdrop,
    },
    '&.str-chat-no-scroll': {
      '.str-chat__list': {
        overflowX: 'hidden',
      },
    },
    '&.messaging': {
      '.str-chat__main-panel': {
        padding: 0,
      },
      '.str-chat__thread': {
        margin: 0,
        marginLeft: '5px',
        borderRadius: 0,
        top: '50px',
        height: 'calc(100% - 50px)',
      },
    },
    '&__input-footer': {
      display: 'none',
    },
    '&__modal': {
      '.str-chat__edit-message-form': {
        '@media screen and (max-width: 960px)': {
          width: '300px',
        },
      },
    },
    '&__no-channels-heading': {
      marginTop: '24px',
      textAlign: 'center',
    },
    '&__loading-channels': {
      width: '200vw',
      height: 'unset',
    },
    '&__loading-channels-item': {
      maxWidth: '300px',
      '@media screen and (max-width: 960px)': {
        marginLeft: '100vw',
      },
    },
    '&__message--me li': {
      textAlign: 'left',
    },
    '.image-gallery-content.fullscreen .image-gallery-slide .image-gallery-image': {
      height: '100%',
    },
    '&__channel-search-results-header': {
      textAlign: 'center',
    },
    '&__channel-search-container': {
      paddingLeft: '0px',
      paddingRight: '0px',
    },
    '&__message-reaction-emoji': {
      paddingTop: '5px',
      marginLeft: '1px',
      marginRight: '1px',
    },
    '&__channel-search:has( .str-chat__channel-search-results-header)': {
      height: '100%',
      overflowY: 'auto',
    },
  },
});
